import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import GeniLoader from '../../components/GeniLoader';
import { buildAuthPageUrl, resolvePostAuthDestination, setPendingProductIntent } from '../../lib/productRouting';

export default function OptionsStart() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    const routeUser = async () => {
      setPendingProductIntent('options');

      if (loading) {
        return;
      }

      if (!user) {
        navigate(buildAuthPageUrl('/signup', '/options', 'options'), { replace: true });
        return;
      }

      const destination = await resolvePostAuthDestination({
        requestedRedirect: '/options',
        allowAcquisition: false,
      });
      navigate(destination, { replace: true });
    };

    routeUser();
  }, [loading, navigate, user]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center" data-testid="options-start-route">
      <div className="flex flex-col items-center gap-4 text-center px-6">
        <GeniLoader size="md" />
        <div>
          <p className="text-white text-lg font-semibold">Abrindo o GENI Options</p>
          <p className="text-white/50 text-sm">Preparando seu fluxo inicial no produto.</p>
        </div>
      </div>
    </div>
  );
}